import { render, staticRenderFns } from "./presentationProductseahourse.vue?vue&type=template&id=9dea1cd4&"
import script from "./presentationProductseahourse.vue?vue&type=script&lang=js&"
export * from "./presentationProductseahourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports